"use server";

import {
  addAvsKvpsSchema,
  editAvsKvpsSchema,
  deleteAvsKvpsSchema,
} from "@/lib/schemas/avs-kvps";
import { validateParams } from "@/lib/utils";
import { prisma } from "@/prisma";
import z from "zod";
import { requireServerRole } from "@/lib/guards";
import { GRP_ROLE_ADMIN } from "@/lib/grp";
import { ActionResult } from "@/types/server-action";

export async function deleteAvsKvps(
  params: z.infer<typeof deleteAvsKvpsSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { id } = validateParams(deleteAvsKvpsSchema, params);

    await prisma.avsKvps.update({
      where: { id },
      data: { deletedAt: new Date() },
    });

    return { success: true };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function addAvsKvps(
  params: z.infer<typeof addAvsKvpsSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { label, kvps } = validateParams(addAvsKvpsSchema, params);

    const avsKvps = await prisma.avsKvps.create({
      data: { label, kvps, isActive: true },
    });

    return { success: true, data: avsKvps };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function editAvsKvps(
  params: z.infer<typeof editAvsKvpsSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const {
      id = -1,
      label,
      kvps,
      isActive = true,
    } = validateParams(editAvsKvpsSchema, params);

    const avsKvps = await prisma.avsKvps.update({
      where: { id },
      data: { label, kvps, isActive },
    });

    return { success: true, data: avsKvps };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
